import React, { useEffect, useState } from 'react';
import { Container } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useCallAction } from '@cobuildlab/react-simple-state';
import { openSnackbarAction } from '../../shared/components/snackbar/snackbar-actions';
import { TypeMessage } from '../../shared/components/snackbar/snackbar-types';
import {
  PlanType,
  PlanDetailsTabs,
} from './plan-types';
import { fetchPlan } from './plan-actions';
import { PlanDetailsForm } from './components/PlanDetailsForm';
import { useDetailsPlanSteps } from './plan-hooks';
import { Loading } from '../../shared/components/Loading';

export const PlanDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [planDetails, setPlanDetails] = useState<PlanType | null>(
    null,
  );
  const [loading, setLoading] = useState(true);
  const { step, handleChangeStep } = useDetailsPlanSteps();

  const stepsView = {
    [PlanDetailsTabs.DETAILS]: (
      <PlanDetailsForm data={planDetails} loading={loading} />
    ),
  };

  const [callFetch] = useCallAction(fetchPlan, {
    onCompleted: (data) => {
      setPlanDetails(data);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    },
    onError: (error) => {
      openSnackbarAction(error.message, TypeMessage.ERROR);
    },
  });

  useEffect(() => {
    handleChangeStep(PlanDetailsTabs.DETAILS);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (id) {
      setLoading(true);
      callFetch({ id });
    }
  }, [callFetch, id]);

  return (
    <Container maxWidth={'lg'} sx={{ py: '10px' }}>
      {loading || !planDetails ? <Loading height="400px" /> : stepsView[step]}
    </Container>
  );
};
